package com.zq.my_official_website

import androidx.compose.runtime.Composable

/**
 * Web 端由 index.html 中的 Chatwoot SDK 脚本渲染右下角气泡，
 * 因此：
 * - 不需要 Compose 侧再画一个浮动按钮（isTawkFabVisible = false）
 * - TawkChatSheet 也什么都不渲染
 */
actual val isTawkFabVisible: Boolean = false

@Composable
actual fun TawkChatSheet(visible: Boolean, onDismiss: () -> Unit) {
    // no-op
}
